import { render, staticRenderFns } from "./ReviewModifyResponsible.vue?vue&type=template&id=7b84d13d&scoped=true"
import script from "./ReviewModifyResponsible.vue?vue&type=script&lang=js"
export * from "./ReviewModifyResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b84d13d",
  null
  
)

export default component.exports